import { API } from "@/main.js";
import url from "@/assets/img_avatar.png";

const state = {
  userInfo: {
    firstName: localStorage.getItem("user_first_name"),
    lastName: localStorage.getItem("user_last_name"),
    image: localStorage.getItem("user_image"),
    id: localStorage.getItem("user_id"),
    uuid: localStorage.getItem("user_uuid")
  },

  isSuperAdmin: false,
  isAdmin: false,
  isManager: false,
  hasTwoAuthentication: localStorage.getItem("user_has_2fa"),

  userPermissions: [],
  // userPermissionsByRole: {
  //   fibercloud_web: null,
  // },

  userWorkspaces: []
};

const getters = {
  currentUserName: state => {
    let name;
    let firstName = state.userInfo.firstName;
    let lastName = state.userInfo.lastName;
    if (firstName !== "" && firstName !== null) {
      name = firstName;
      if (lastName !== null) name += " " + lastName;
    } else {
      name = "User";
    }
    return name;
  },
  currentUserImage: state => state.userInfo.image,
  currentUserID: state => state.userInfo.id,
  currentUserUuid: state => state.userInfo.uuid,
  currentUserFirstName: state => state.userInfo.firstName,

  isSuperAdmin: state => state.isSuperAdmin,
  isAdmin: state => state.isAdmin,
  isManager: state => state.isManager,
  // hasPermissionInRole: state => (permissionName, role) => {
  //   if (state.isSuperAdmin) {
  //     return true;
  //   } else
  //     return (
  //       state.userPermissionsByRole[role].find(
  //         permission => permission.name === permissionName
  //       ) !== undefined
  //     );
  // },

  currentWorkspaces: state => state.userWorkspaces,

  // userPermissionsByRole: state => role => {
  //   return state.userPermissionsByRole[role];
  // },

  userHasPermission: state => (permissionName) => {
    if (state.isSuperAdmin) {
      return true;
    } else {
      return (state.userPermissions.find(permission => permission.name === permissionName) !== undefined)
    }
  },

  hasTwoAuthentication: state => state.hasTwoAuthentication,

  getUserPermissions: state => {
    if (state.userPermissions.length !== 0) {
      return state.userPermissions
    } else return [];
  },
};

const mutations = {
  setUserFirstName(state, firstName) {
    state.userInfo.firstName = firstName;
    localStorage.setItem("user_first_name", firstName || "");
  },

  setUserLastName(state, lastName) {
    state.userInfo.lastName = lastName;
    localStorage.setItem("user_last_name", lastName || "");
  },

  setUserImage(state, image) {
    state.userInfo.image = image;
    localStorage.setItem("user_image", image === null ? url : image);
  },

  setUserID(state, id) {
    state.userInfo.id = id;
    localStorage.setItem("user_id", id || "");
  },

  setUserUuid(state, uuid) {
    state.userInfo.uuid = uuid;
    localStorage.setItem("user_uuid", uuid || "");
  },

  // setuserPermissions(state, rolesAndPermissions) {
  //   state.userPermissions = rolesAndPermissions;
  // },

  setCurrentUserPermissions(state, permissions) {
    state.userPermissions= permissions;
  },

  setUserWorkspaces(state, workspaces) {
    state.userWorkspaces = workspaces;
  },

  setIsSuperAdmin(state, value) {
    state.isSuperAdmin = value;
  },

  setIsAdmin(state, value) {
    state.isAdmin = value;
  },

  setIsManager(state, value) {
    state.isManager = value;
  },

  setTwoAuthentication(state, value) {
    state.hasTwoAuthentication = value;
    localStorage.setItem("user_has_2fa", value);
  }
};

const actions = {
  fetchUserDetails({ commit }) {
    return new Promise((resolve, reject) => {
      API.auth.getDetails(
        resp => {
          let data = resp.data.data;
          commit("setUserFirstName", data.first_name);
          commit("setUserLastName", data.last_name);
          commit("setUserImage", data.image);
          commit("setUserID", data.id);
          commit("setUserUuid", data.uuid);
          commit("setTwoAuthentication", data.has_two_factor_authentication);
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },

  clearUserDetails() {
    localStorage.removeItem("user_first_name");
    localStorage.removeItem("user_last_name");
    localStorage.removeItem("user_image");
    localStorage.removeItem("current_user_email");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_uuid");
    localStorage.removeItem("user_has_2fa");
  },

  clearUserPermissions({ commit }) {
    // commit("setuserPermissions", []);

    // commit("setCurrentUserPermissions", {
      //   roleName: "management",
      //   permissions: null
    // });
    // commit("setCurrentUserPermissions", {
    //   roleName: "modules",
    //   permissions: null
    // });
    // commit("setCurrentUserPermissions", {
    //   roleName: "network",
    //   permissions: null
    // });

    commit("setCurrentUserPermissions", []);
    commit("setIsSuperAdmin", false);
    commit("setIsAdmin", false);
    commit("setIsManager", false);
  },

  fetchUserPermissionsAndRoles({ commit }) {
    return new Promise((resolve, reject) => {
      API.auth.rolesByUserAndCompany(
        resp => {
          let data = resp.data.data;

          commit("setCurrentUserPermissions", data.permissions);
          commit("setIsSuperAdmin", data.isSuperAdmin);
          commit("setIsAdmin", data.isAdmin);
          commit("setIsManager", data.isManager);
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // setCurrentUserPermissions({ commit }) {
  //   let permissions = getUserPermissions();
  //   commit("setCurrentUserPermissions", permissions);
  // },

  fetchUserAndCompanyWorkspaces({ commit }) {
    return new Promise((resolve, reject) => {
      API.auth.workspacesByUserAndCompany(
        resp => {
          let workspaces = resp.data.data;
          commit("setUserWorkspaces", workspaces);
          resolve(workspaces);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

function getUserPermissions() {
  if (state.userPermissions.length !== 0) {
    return state.userPermissions
  } else return [];
}

function hasRole(role, roleType) {
  return role.role_level === roleType;
}

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/currentUser.js